import React, { forwardRef, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Section from '@polestar/component-warehouse-react/components/section/Section';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import Grid from '@polestar/component-warehouse-react/components/grid/Grid';
import GridColumn from '@polestar/component-warehouse-react/components/grid/GridColumn';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import { HeroSectionCommonButtonGroup, HeroSectionCommonTitleGroup } from './HeroSectionCommon';
import Column from '@polestar/component-warehouse-react/components/column/Column';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import Breakpoints from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
const HeroSectionTextual = forwardRef(({ title, tagline, intro, buttonOne, buttonTwo, ...props }, ref) => {
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < Breakpoints.tablet);
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (React.createElement(SectionContainer, { ...props, ref: ref },
        React.createElement(StyledGrid, null,
            React.createElement(GridColumn, { span: { mobile: 4, tablet: 8, desktop: 5, desktopWide: 4 } },
                React.createElement(HeroSectionCommonTitleGroup, { title: title, tagline: tagline })),
            React.createElement(GridColumn, { span: { mobile: 4, tablet: 8, desktop: 7, desktopWide: 8 } },
                React.createElement(IntroAndButtons, null,
                    React.createElement(Paragraph, { size: isMobile ? Sizes.medium : Sizes.large }, intro),
                    React.createElement(HeroSectionCommonButtonGroup, { buttonOne: buttonOne, buttonTwo: buttonTwo }))))));
});
HeroSectionTextual.displayName = 'HeroSectionTextual';
export default HeroSectionTextual;
const SectionContainer = styled(Section)(css `
  ${responsiveStyles({
    paddingBlock: {
        mobile: Spacings.large,
        tablet: Spacings.xLarge,
        desktop: createCustomSpacing(2.5),
    },
})}
`);
const IntroAndButtons = styled(Column)(css `
  gap: ${Spacings.medium};
`);
const StyledGrid = styled(Grid)(css `
  ${responsiveStyles({
    gridGap: {
        mobile: Spacings.medium,
        tablet: Spacings.medium,
        desktop: Spacings.medium,
        desktopWide: Spacings.medium,
    },
})}
`);
